import { useNavigate } from "react-router-dom";
import { popupType } from "../../../globals/constants";
import { publicUser } from "../../../globals/route-names";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function YesNoPopup(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // useEffect(() => {
    //     const token = localStorage.getItem("authToken");
    //     if (!token) {
    //         navigate(publicUser.pages.INITIAL);
    //     }
    // }, [navigate]);

    const yesHandler = () => {
        if (props.type === popupType.LOGOUT) {
            localStorage.removeItem("authToken");
            localStorage.removeItem("role");
            navigate(publicUser.pages.LOGIN);
            window.location.reload();
        }
    };

    return (
        <div
            className="modal fade twm-model-popup"
            id={props.id}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <h4 className="modal-title">{props.msg}</h4>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="site-button" data-bs-dismiss="modal">{t("No")}</button>
                        <button
                            type="button"
                            className="site-button outline-primary"
                            data-bs-dismiss="modal"
                            onClick={yesHandler}
                        >
                            {t("Yes")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default YesNoPopup;
